import { CatalogueProduct } from 'dataQueries/purchase.query'

/**
 * Pick the extra catalogue product that applies to a given parent (main) product.
 *
 * Why per-parent: extras like the 3D floor-plan add-on are scoped by size — a
 * different `CatalogueProduct` exists for each main-product size, each listing its
 * applicable parents in `parentProductIds`. Resolving the extra must happen per
 * main product, otherwise every main product ends up with the same add-on attached.
 *
 * Rules:
 *  1. Prefer an extra whose `parentProductIds` contains the given parent id.
 *  2. Fall back to an extra with no parent scoping (legacy catch-all).
 *  3. Return `undefined` if neither matches.
 */
export function findExtraProductByParent(
  extras: CatalogueProduct[],
  parentProductId: number
): CatalogueProduct | undefined {
  const parentMatch = extras.find(extra => extra.parentProductIds?.includes(parentProductId))
  if (parentMatch) return parentMatch

  return extras.find(extra => !extra.parentProductIds?.length)
}
